import { render, staticRenderFns } from "./SitesFormPage1.vue?vue&type=template&id=08efbb86"
import script from "./SitesFormPage1.vue?vue&type=script&lang=js"
export * from "./SitesFormPage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports